import Immutable from "immutable";
import React from "react";
import _ from "underscore";
import { Entity } from "draft-js";
import { ReferenceCitation as Reference } from "@ep/editor";

class ReferenceCitation extends React.Component {
  constructor(props) {
    super(props);

    this.getReferences = this.getReferences.bind(this);
  }

  getReferences() {
    const { refIds, references } = Entity.get(this.props.entityKey).getData();
    return refIds.reduce((refsList, refId) => {
      if (_(refsList).contains(refId)) return refsList;
      return refsList.push(Immutable.fromJS(references[refId]));
    }, Immutable.List());
  }

  render() {
    return <Reference references={this.getReferences()} {...this.props} />;
  }
}

export default ReferenceCitation;
